import { useApplicationProcess } from 'src/hooks/useApplicationProcess';
import { notEmpty } from 'src/utils';

export const usePrivacyPolicy = () => {
  const { loading, error, data: applicationProcess } = useApplicationProcess();

  if (applicationProcess?.questionnaire) {
    const questions = applicationProcess?.questionnaire?.questions || [];
    const asRoleRequirements = questions
      .map((q) => {
        if (q?.__typename === 'PrivacyPolicyQuestion') {
          return {
            id: q.id,
            url: q.url,
            text: q.text,
          };
        }
        return null;
      })
      .filter(notEmpty);

    return {
      loading,
      error,
      data: asRoleRequirements?.[0],
    };
  }

  return {
    loading,
    error,
  };
};

export type PrivacyPolicy = ReturnType<typeof usePrivacyPolicy>['data'];
